export default __webpack_public_path__ + "static/media/search-base.15987de6.png";